{
  "familyId": "MET-OPP-PARALLELLOGRAM",
  "questions": [
    {
      "id": "MET-OPP-PARALLELLOGRAM-001",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "multiple_choice",
      "question": "Een parallellogram heeft een basis van 8 cm en een hoogte van 5 cm. Wat is de oppervlakte?",
      "options": ["40 cm²", "48 cm²", "20 cm²", "13 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "parallelogram",
            "base": 8,
            "height": 5,
            "showGrid": true,
            "unit": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte parallellogram",
            "content": "Oppervlakte parallellogram = basis × hoogte. De hoogte is de loodrechte afstand tussen de twee evenwijdige zijden, niet de schuine zijde!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Oppervlakte parallellogram = basis × hoogte = 8 × 5 = 40 cm². Waarom dezelfde formule als een rechthoek? Omdat je een parallellogram kunt omvormen tot een rechthoek door een driehoekje af te knippen en aan de andere kant te plakken. Let op: je gebruikt de hoogte (loodrecht op de basis), niet de schuine zijde.",
        "solutionSteps": [
          "Formule: oppervlakte = basis × hoogte",
          "Basis = 8 cm, hoogte = 5 cm",
          "8 × 5 = 40 cm²",
          "Check: de hoogte staat loodrecht op de basis ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Basis × hoogte = 8 × 5 = 40 cm².",
          "1": "Je dacht waarschijnlijk dat je de schuine zijde (6 cm) moest gebruiken in plaats van de hoogte (5 cm). Maar bij een parallellogram gebruik je altijd de loodrechte hoogte: 8 × 5 = 40 cm², niet 8 × 6 = 48 cm². Onthoud: hoogte = loodrecht op de basis.",
          "2": "Je dacht waarschijnlijk dat je de formule van een driehoek moest gebruiken (basis × hoogte ÷ 2). Maar een parallellogram is geen driehoek — het is een volledige rechthoek qua oppervlakte. Onthoud: parallellogram = basis × hoogte (zonder ÷ 2).",
          "3": "Je dacht waarschijnlijk dat je 8 + 5 = 13 moest doen. Maar oppervlakte bereken je met vermenigvuldigen, niet met optellen. Onthoud: oppervlakte = basis × hoogte."
        }
      }
    },
    {
      "id": "MET-OPP-PARALLELLOGRAM-002",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "multiple_choice",
      "question": "Een parallellogram heeft een basis van 12 cm, een schuine zijde van 7 cm, en een hoogte van 6 cm. Welke maten gebruik je voor de oppervlakte?",
      "options": [
        "Basis (12 cm) en schuine zijde (7 cm)",
        "Schuine zijde (7 cm) en hoogte (6 cm)",
        "Basis (12 cm) en hoogte (6 cm)",
        "Alle drie de maten"
      ],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "parallelogram",
            "base": 12,
            "height": 6,
            "showGrid": true,
            "unit": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Welke maten?",
            "content": "Voor de oppervlakte van een parallellogram gebruik je alleen de basis en de hoogte. De schuine zijde gebruik je NIET. De hoogte staat altijd loodrecht op de basis.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_maten",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Je gebruikt de basis (12 cm) en de hoogte (6 cm). De schuine zijde (7 cm) gebruik je niet voor de oppervlakte. Oppervlakte = 12 × 6 = 72 cm². Waarom niet de schuine zijde? Omdat de hoogte de loodrechte afstand is — dat is de echte 'breedte' van de figuur.",
        "solutionSteps": [
          "Formule: oppervlakte = basis × hoogte",
          "Basis = 12 cm, hoogte = 6 cm",
          "De schuine zijde (7 cm) is niet nodig voor oppervlakte",
          "12 × 6 = 72 cm² ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je de schuine zijde nodig hebt. Maar de oppervlakte bereken je met de loodrechte hoogte, niet de schuine zijde. Onthoud: hoogte = loodrecht op de basis.",
          "1": "Je dacht waarschijnlijk dat de schuine zijde en hoogte genoeg zijn. Maar je hebt de basis nodig, niet de schuine zijde. Onthoud: oppervlakte = basis × hoogte.",
          "2": "Goed! Alleen basis en hoogte zijn nodig voor de oppervlakte.",
          "3": "Je dacht waarschijnlijk dat je alle maten nodig hebt. Maar voor de oppervlakte zijn alleen basis en hoogte nodig. Onthoud: de schuine zijde is alleen nodig voor de omtrek."
        }
      }
    },
    {
      "id": "MET-OPP-PARALLELLOGRAM-003",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "multiple_choice",
      "question": "Waarom is de oppervlakte van een parallellogram gelijk aan basis × hoogte (dezelfde formule als een rechthoek)?",
      "options": [
        "Omdat een parallellogram altijd even groot is als een rechthoek",
        "Omdat je een parallellogram kunt 'knippen en plakken' tot een rechthoek",
        "Omdat alle vierhoeken dezelfde formule hebben",
        "Omdat de schuine zijden er niet toe doen"
      ],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Parallellogram → rechthoek",
            "content": "Als je een driehoek van de ene kant van een parallellogram afknipt en aan de andere kant plakt, krijg je een rechthoek. Daarom is de oppervlakte hetzelfde: basis × hoogte.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_begrip",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Je kunt een parallellogram omvormen tot een rechthoek door een driehoekje af te knippen en aan de andere kant te plakken. De oppervlakte verandert niet. Daarom geldt: basis × hoogte — precies dezelfde formule als voor een rechthoek.",
        "solutionSteps": [
          "Knip een driehoek af aan de schuine kant",
          "Plak die driehoek aan de andere kant",
          "Je krijgt een rechthoek met dezelfde basis en hoogte",
          "Oppervlakte rechthoek = basis × hoogte → ook voor parallellogram ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat elk parallellogram even groot is als een rechthoek. Maar dat hangt af van de maten. Het punt is dat je elk parallellogram kunt omvormen tot een rechthoek met dezelfde basis en hoogte.",
          "1": "Goed! Door te knippen en plakken maak je een rechthoek met dezelfde oppervlakte.",
          "2": "Je dacht waarschijnlijk dat alle vierhoeken dezelfde formule hebben. Maar een ruit, trapezium of willekeurige vierhoek hebben andere formules. Onthoud: alleen rechthoek en parallellogram delen deze formule.",
          "3": "Je dacht waarschijnlijk dat de schuine zijden er niet toe doen. Ze doen er wel toe voor de omtrek, maar niet voor de oppervlakte. De reden is het knip-en-plak principe."
        }
      }
    },
    {
      "id": "MET-OPP-PARALLELLOGRAM-004",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "multiple_choice",
      "question": "Een tuinier legt een bloembed in de vorm van een parallellogram. De basis is 3 meter en de hoogte is 1,5 meter. Hoeveel vierkante meter grond heeft hij nodig?",
      "options": ["9 m²", "2,25 m²", "6 m²", "4,5 m²"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "parallelogram",
            "base": 3,
            "height": 1.5,
            "showGrid": false,
            "unit": "m"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte met kommagetallen",
            "content": "Oppervlakte = basis × hoogte. Met kommagetallen: 3 × 1,5 = 4,5. Tip: 3 × 1 = 3, en 3 × 0,5 = 1,5. Samen: 3 + 1,5 = 4,5 m².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_context",
      "variantIndex": 4,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Oppervlakte = basis × hoogte = 3 × 1,5 = 4,5 m². De tuinier heeft 4,5 vierkante meter grond nodig. Handig rekenen met kommagetallen: splits 1,5 in 1 + 0,5. Dan: 3 × 1 = 3 en 3 × 0,5 = 1,5. Samen: 3 + 1,5 = 4,5 m².",
        "solutionSteps": [
          "Formule: oppervlakte = basis × hoogte",
          "3 × 1,5 = 4,5",
          "Eenheid: m × m = m²",
          "Antwoord: 4,5 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat je 2 × (3 + 1,5) = 9 moest doen. Maar dat is de omtrek, niet de oppervlakte. Onthoud: oppervlakte = basis × hoogte, omtrek = alle zijden optellen.",
          "1": "Je dacht waarschijnlijk dat je de driehoekformule moest gebruiken: 3 × 1,5 ÷ 2 = 2,25. Maar een parallellogram is geen driehoek. Onthoud: parallellogram = basis × hoogte (zonder ÷ 2).",
          "2": "Je dacht waarschijnlijk dat je 3 + 1,5 + 1,5 = 6 moest doen. Maar oppervlakte bereken je met vermenigvuldigen, niet met optellen. Onthoud: oppervlakte = basis × hoogte.",
          "3": "Goed! 3 × 1,5 = 4,5 m²."
        }
      }
    },
    {
      "id": "MET-OPP-PARALLELLOGRAM-005",
      "familyId": "MET-OPP-PARALLELLOGRAM",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_parallellogram",
      "questionType": "fill_in",
      "question": "Een parallellogram heeft een oppervlakte van 54 cm² en een basis van 9 cm. Hoe hoog is het parallellogram? Geef je antwoord in cm.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["6", "6 cm"],
        "caseSensitive": false,
        "placeholder": "? cm"
      },
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "parallelogram",
            "base": 9,
            "height": 6,
            "hideHeight": true,
            "showGrid": true,
            "unit": "cm"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoogte berekenen",
            "content": "Als je de oppervlakte en de basis weet, bereken je de hoogte met: hoogte = oppervlakte ÷ basis. Dus 54 ÷ 9 = 6 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "opp_parallellogram_hoogte",
      "variantIndex": 5,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Oppervlakte = basis × hoogte. Draai de formule om: hoogte = oppervlakte ÷ basis = 54 ÷ 9 = 6 cm. Controleer: 9 × 6 = 54 cm² ✓. Onthoud: als je twee van de drie waarden kent (oppervlakte, basis, hoogte), kun je de derde altijd berekenen door de formule om te draaien.",
        "solutionSteps": [
          "Formule: oppervlakte = basis × hoogte",
          "Omdraaien: hoogte = oppervlakte ÷ basis",
          "54 ÷ 9 = 6 cm",
          "Check: 9 × 6 = 54 cm² ✓"
        ]
      }
    }
  ]
}